import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  IconButton,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  Typography,
  Tab,
  Tabs,
  Checkbox,
  FormControl,
  Chip,
  ClickAwayListener,
  Paper,
  Popper,
  InputAdornment,
  TextField,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import SearchBar2 from "../../components/SearchBar2";
import { isValidInput } from "../../utils/validation";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import ClearIcon from "@mui/icons-material/Clear";
import WarnModal from "../../components/WarnModal";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { ProductType } from "../../types/General";
import {
  useExchangeAcceptRejectMutation,
  useGetReturnExchangeMutation,
  useReturnAcceptRejectMutation,
  useUpdateReturnExchangeStatusMutation,
} from "../../services/returnExchange";
import moment from "moment";
import { errorToast, STORAGE_KEYS, successToast } from "../../helpers";
import Loader from "../../helpers/constants/Loader";
import { DayPicker } from "react-day-picker";
import { getFromStorage } from "../../constants/storage";
// import { STORAGE_KEYS } from "../../constants/storageKeys";
import useTranslation from "../../hooks/Translation";

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageReturnExchange = () => {
  const navigate = useNavigate();
  const t = useTranslation();
  const getLang = getFromStorage(STORAGE_KEYS.language);
  const IconLeft = getLang === "ar" ? ArrowForwardIcon : ArrowBackIcon;
  const IconRight = getLang === "ar" ? ArrowBackIcon : ArrowForwardIcon;
  const currency = getFromStorage(STORAGE_KEYS.currency);
  const [getOrderListing] = useGetReturnExchangeMutation();
  const [orderStatus] = useUpdateReturnExchangeStatusMutation();
  const [returnAcceptReject] = useReturnAcceptRejectMutation();
  const [exchangeAcceptReject] = useExchangeAcceptRejectMutation();
  const [loading, setLoading] = useState(false);
  const [value, setValue] = React.useState(0);
  const [selectedChip, setSelectedChip] = useState("");
  const [orderData, setOrderData] = useState<any>([]);
  const [limit, setLimit] = useState<number>(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [filter, setFilter] = useState<string>("");
  const [month, setMonth] = useState(new Date());
  const [page, setPage] = useState(1);
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<any | null>(null);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [selectedSubCat, setSelectedSubCat] = useState<string>("");
  const [open1, setOpen1] = useState(false); // Control calendar visibility
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const RETURN_STATUS = [
    [1, "RETURN_REQUEST_SENT"],
    [2, "RETURN_REQUEST_RECEIVED"],
    [3, "VENDOR_REQUEST_ACCEPTED"],
    [4, "VENDOR_REQUEST_REJECTED"],
    [5, "RETURN_PICKUP_SCHEDULED"],
    [6, "RETURN_PICKED_UP"],
    [7, "RETURN_IN_TRANSIT"],
    [8, "RETURN_RECEIVED_BY_VENDOR"],
    [9, "RETURN_COMPLETED"],
  ];

  // Custom labels for each status
  const STATUS_LABELS: any = {
    1: t.main.orderPlaced,
    2: t.main.requestReceived,
    3: t.main.vendorAccepted,
    4: t.main.vendorRejected,
    5: t.main.pickupScheduled,
    6: t.main.pickedUp,
    7: t.main.inTransit,
    8: t.main.receivedByVendor,
    9: t.main.returnComplete,
  };
  const EXCHANGE_STATUS: any = [
    [1, "EXCHANGE_REQUEST"],
    [2, "VENDOR_REQUEST_ACCEPT"],
    [3, "VENDOR_REQUEST_REJECT"],
    [4, "EXCHANGE_INITIATE"],
    [5, "ITEM_PICKED_UP"],
    [6, "ITEM_IN_TRANSIT"],
    [7, "ITEM_RECEIVED_BY_VENDOR"],
    [8, "REPLACEMENT_DISPATCHED"],
    [9, "REPLACEMENT_DELIVERED"],
    [10, "EXCHANGE_COMPLETE"],
  ];
  const EXCHANGE_STATUS_LABELS: any = {
    1: t.main.requestReceived,
    2: t.main.vendorAcceptedReq,
    3: t.main.vendorRejectedReq,
    4: t.main.ExchangeInit,
    5: t.main.itemPickedUp,
    6: t.main.itemInTransit,
    7: t.main.itemReceivedByVendor,
    8: t.main.replacementDispatched,
    9: t.main.replacementDelivered,
    10: t.main.exchangeComplete,
  };

  const handleSelect = (selectedRange: any) => {
    if (selectedRange === undefined) {
      setRange({ from: undefined, to: undefined });
    } else {
      setRange(selectedRange);
      if (
        selectedRange.from !== undefined &&
        selectedRange.to !== undefined &&
        selectedRange.from !== selectedRange.to
      ) {
        setOpen1(false);
      }
    }
  };
  const [range, setRange] = useState<{
    from: Date | undefined;
    to: Date | undefined;
  }>({
    from: undefined,
    to: undefined,
  });

  const getData = async (page: number) => {
    setLoading(true);
    try {
      let body = {
        start: page,
        length: 10,
        type: value == 0 ? 2 : 1,
        search: debouncedSearchTerm,
        ...(range?.from
          ? { start_date: moment(range?.from).startOf("day") }
          : {}),
        ...(range?.to ? { end_date: moment(range?.to).startOf("day") } : {}),
      };

      const res = await getOrderListing(body).unwrap();
      if (res?.status === 200) {
        setLoading(false);
        setOrderData(res?.data?.response_object);
        // setTotalRecords(res?.data?.total_records);
      } else {
        setLoading(false);
        console.log("error");
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const handleClose = () => {
    setOpen1(false);
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setOpen1(true);
  };

  const handleMonthChange = (newMonth: any) => {
    setMonth(newMonth);
  };

  const getFormattedRange = () => {
    if (range?.from && range?.to) {
      return `${moment(range.from).format("MM/DD/YYYY")} - ${moment(
        range.to
      ).format("MM/DD/YYYY")}`;
    } else if (range?.from) {
      return moment(range.from).format("MM/DD/YYYY");
    }
    return "";
  };

  const handleRequestStatus = async (status: any, id: any) => {
    const currentDate = new Date().toISOString();
    const statusValue = Number(status.target.value);

    const statusMapping: any = {
      1: {
        type: value === 0 ? 2 : 1,
        return_request_sent_date: currentDate,
      },
      2: {
        type: value === 0 ? 2 : 1,
        return_request_received_date: currentDate,
      },
      3: {
        type: value === 0 ? 2 : 1,
        vendor_request_accepted_date: currentDate,
      },
      4: {
        type: value === 0 ? 2 : 1,
        vendor_request_rejected_date: currentDate,
      },
      5: {
        type: value === 0 ? 2 : 1,
        return_pickup_scheduled_date: currentDate,
      },
      6: { type: value === 0 ? 2 : 1, return_picked_up_date: currentDate },
      7: { type: value === 0 ? 2 : 1, return_in_transit_date: currentDate },
      8: {
        type: value === 0 ? 2 : 1,
        return_received_by_vendor_date: currentDate,
      },
      9: { type: value === 0 ? 2 : 1, return_completed_date: currentDate },
    };
    const exchangeStatusMapping: any = {
      1: { type: value === 0 ? 2 : 1, exchange_request_date: currentDate },
      2: {
        type: value === 0 ? 2 : 1,
        vendor_request_accepted_date: currentDate,
      },
      3: {
        type: value === 0 ? 2 : 1,
        vendor_request_reject_date: currentDate,
      },
      4: { type: value === 0 ? 2 : 1, exchange_initiate_date: currentDate },
      5: { type: value === 0 ? 2 : 1, item_picked_up_date: currentDate },
      6: { type: value === 0 ? 2 : 1, item_in_transit_date: currentDate },
      7: {
        type: value === 0 ? 2 : 1,
        item_received_by_vendor_date: currentDate,
      },
      8: {
        type: value === 0 ? 2 : 1,
        replacement_dispatched_date: currentDate,
      },
      9: {
        type: value === 0 ? 2 : 1,
        replacement_delivered_date: currentDate,
      },
      10: {
        type: value === 0 ? 2 : 1,
        exchange_complete_date: currentDate,
      },
    };

    const body =
      value == 1
        ? {
            type: statusMapping[statusValue]?.type,
            ...statusMapping[statusValue],
            Return_status: statusValue,
          }
        : {
            type: exchangeStatusMapping[statusValue]?.type,
            ...exchangeStatusMapping[statusValue],
            exchange_status: statusValue,
          };

    try {
      const response = await orderStatus({ body, id }).unwrap();
      if (response?.status === 200) {
        getData(page);
        // successToast("Status updated successfully");
        const message =
          value === 1
            ? `${t.main.returnStatusUpdatedTo}: ${STATUS_LABELS[statusValue]}`
            : `${t.main.exchangeStatusUpdatedTo}: ${EXCHANGE_STATUS_LABELS[statusValue]}`;

        successToast(message);
      } else {
        errorToast("Please try again");
      }
    } catch (error) {
      console.error(error);
      setOrderData([]);
      errorToast("An error occurred");
    }
  };

  const handleChipClick = (value: any) => {
    if (value === selectedChip) {
      setSelectedChip("");
      setRange({ from: undefined, to: undefined });
      setMonth(moment().toDate());
      return;
    }
    setSelectedChip(value);

    let newRange = { from: moment().toDate(), to: moment().toDate() };
    const today = moment();

    if (value === "lastMonth") {
      newRange = {
        from: moment().subtract(1, "months").startOf("month").toDate(),
        to: moment().subtract(1, "months").endOf("month").toDate(),
      };
    } else if (value === "lastWeek") {
      newRange = {
        from: moment().subtract(7, "days").startOf("day").toDate(),
        to: today.toDate(),
      };
    } else if (value === "lastYear") {
      newRange = {
        from: moment().subtract(1, "years").startOf("year").toDate(),
        to: moment().subtract(1, "years").endOf("year").toDate(),
      };
    }
    setRange(newRange);
    setMonth(newRange.from);
  };

  const handleAcceptRejectReturn = async (id: any, type: any) => {
    const body = {
      type: type,
      vendor_request_rejected_date: new Date().toISOString(),
    };

    const body2 = {
      type: type,
      vendor_request_accepted_date: new Date().toISOString(),
    };

    try {
      const response = await returnAcceptReject({
        body: type === 1 ? body2 : body,
        id,
      }).unwrap();
      if (response?.status === 200) {
        if (type === 1) {
          successToast(t.main.orderAcceptedSuccessFully);
        } else {
          successToast(t.main.orderRejectedSuccessfully);
        }

        getData(page);
      }
    } catch (error) {
      console.log(error, "errror");
      // errorToast(error?.data?.message || "");
    }
  };

  const handleAcceptRejectExchange = async (id: any, type: any) => {
    const body = {
      type: type,
      vendor_request_rejected_date: new Date().toISOString(),
    };

    const body2 = {
      type: type,
      vendor_request_accepted_date: new Date().toISOString(),
    };

    try {
      const response = await exchangeAcceptReject({
        body: type === 1 ? body2 : body,
        id,
      }).unwrap();
      if (response?.status === 200) {
        successToast(t.main.updatedSuccess);
        getData(page);
      }
    } catch (error) {
      console.log(error, "errror");
      // errorToast(error?.data?.message || "");
    }
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    setPage(1);
  };

  useEffect(() => {
    getData(page);
  }, [value, debouncedSearchTerm, range?.from, range?.to]);

  return (
    <div>
      <Loader isLoad={loading} />
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">{t.sideBar.manageReturnExchange}</h1>
        </div>
        <Card className="cards">
          <Box className="cards_header">
            <div className="cards_header_left">
              <SearchBar2
                value={searchTerm}
                searchTerm={searchTerm}
                onCross={() => setSearchTerm("")}
                setDebouncedSearchTerm={setDebouncedSearchTerm}
                onChange={(val: any) => {
                  if (isValidInput(val.target.value)) {
                    setSearchTerm(val.target.value);
                  }
                }}
              />
              <div className="control_group" style={{ width: 250 }}>
                <TextField
                  // label="Select Date Range"
                  variant="outlined"
                  hiddenLabel
                  className="text_field-range"
                  fullWidth
                  onClick={handleClick}
                  value={getFormattedRange()}
                  placeholder={t.main.selectDateRange}
                  InputProps={{
                    readOnly: true,
                    endAdornment: range?.from ? (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => {
                            setRange({
                              from: undefined,
                              to: undefined,
                            });
                          }}
                        >
                          <ClearIcon />
                        </IconButton>
                      </InputAdornment>
                    ) : (
                      <InputAdornment position="end">
                        <IconButton>
                          <CalendarTodayIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
              <Popper
                open={open1}
                anchorEl={anchorEl}
                placement="bottom-start"
                disablePortal
                style={{
                  position: "relative",
                  zIndex: 1,
                }}
              >
                <ClickAwayListener onClickAway={handleClose}>
                  <Paper
                    elevation={3}
                    style={{ position: "relative", zIndex: 1 }}
                  >
                    <div
                      style={{
                        padding: 16,
                        borderRadius: 10,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-around",
                        }}
                      >
                        <Chip
                          label={t.main.lastWeek}
                          variant={
                            selectedChip === "lastWeek" ? "filled" : "outlined"
                          }
                          onClick={() => handleChipClick("lastWeek")}
                        />
                        <Chip
                          label={t.main.lastMonth}
                          variant={
                            selectedChip === "lastMonth" ? "filled" : "outlined"
                          }
                          onClick={() => handleChipClick("lastMonth")}
                        />
                        <Chip
                          label={t.main.lastYear}
                          variant={
                            selectedChip === "lastYear" ? "filled" : "outlined"
                          }
                          onClick={() => handleChipClick("lastYear")}
                        />
                      </div>

                      <DayPicker
                        className="react-day-picker"
                        mode="range"
                        selected={range}
                        onSelect={handleSelect}
                        // numberOfMonths={10}
                        month={month}
                        onMonthChange={handleMonthChange}
                        dir={getLang === "ar" ? "rtl" : "ltr"}

                        // styles={{
                        //   months: { display: "flex", gap: "16px" },
                        //   month: { margin: 0 },
                        // }}
                      />
                    </div>
                  </Paper>
                </ClickAwayListener>
              </Popper>
            </div>

            <Box className="cards_header_right"></Box>
          </Box>
          <div style={{ margin: 20 }}></div>
          <Box className="custom_tabs">
            <Tabs
              value={value}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label={t.main.exchange} {...a11yProps(0)} />
              <Tab label={t.main.return} {...a11yProps(1)} />
            </Tabs>
            <TableContainer className="table_container">
              <Table sx={{ minWidth: 650 }} aria-label="sub-category table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">S.No</TableCell>
                    <TableCell>{t.main.orderId}</TableCell>
                    <TableCell>{t.main.customerName}</TableCell>
                    <TableCell>{t.main.contact}</TableCell>
                    <TableCell>{t.main.email}</TableCell>
                    <TableCell>{t.main.refundAmount}</TableCell>
                    {value === 0 ? (
                      <TableCell>{t.main.extraAmountPay}</TableCell>
                    ) : null}

                    <TableCell>{t.main.totalCostPay}</TableCell>
                    <TableCell>{t.main.date}</TableCell>
                    <TableCell>{t.main.orderStatus}</TableCell>
                    <TableCell>{t.main.acceptReject}</TableCell>
                    {/* <TableCell>Action</TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {orderData?.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={11} align="center">
                        {t.error.noData}
                      </TableCell>
                    </TableRow>
                  ) : (
                    orderData?.map((item: any, index: number) => (
                      <TableRow key={item?.id}>
                        <TableCell align="center">
                          {(page - 1) * limit + index + 1}
                        </TableCell>
                        <TableCell>{item?.order_track_id || "-"}</TableCell>
                        <TableCell>{item?.user || "-"}</TableCell>
                        <TableCell>{`${item?.country_code || ""} ${item?.phone_no || "-"}`}</TableCell>
                        <TableCell>{item?.email || "-"}</TableCell>
                        <TableCell>
                          {currency === "USD" ? "USD" : "AED"}{" "}
                          {value === 0 ? item?.refund_pay : item?.amount_pay}
                        </TableCell>

                        {value === 0 ? (
                          <TableCell>
                            {currency === "USD" ? "USD" : "AED"}{" "}
                            {item?.extra_amount_pay || "0"}
                          </TableCell>
                        ) : null}
                        <TableCell>
                          {currency === "USD" ? "USD" : "AED"}{" "}
                          {value === 0
                            ? item?.Exchange_total_cost_pay
                            : item?.total_cost_pay}
                        </TableCell>
                        <TableCell>
                          {moment(item?.created_at).format("MM/DD/YYYY")}
                        </TableCell>
                        <TableCell>
                          <FormControl fullWidth>
                            <Select
                              className="select_div"
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={
                                value == 1
                                  ? String(item?.Return_status)
                                  : String(item?.exchange_status)
                              }
                              disabled={
                                item?.Return_status === 4 ||
                                item?.exchange_status === 3
                              }
                              displayEmpty
                              onChange={(val) =>
                                handleRequestStatus(val, item?.id)
                              }
                            >
                              {value === 1
                                ? RETURN_STATUS?.filter(
                                    ([value]) =>
                                      (value !== 3 ||
                                        item?.Return_status === 3) &&
                                      (value !== 4 || item?.Return_status === 4)
                                  ).map(([value, status]) => (
                                    <MenuItem
                                      key={value}
                                      value={String(value)}
                                      disabled={
                                        item?.Return_status === 2
                                          ? value > item?.Return_status + 2
                                          : item?.Return_status === 3
                                            ? value > item?.Return_status + 2
                                            : value > item?.Return_status + 1 ||
                                              value < item?.Return_status
                                      }
                                    >
                                      {STATUS_LABELS[value] || status}
                                    </MenuItem>
                                  ))
                                : EXCHANGE_STATUS?.filter(
                                    ([value]: any) =>
                                      (value !== 2 ||
                                        item?.exchange_status === 2) &&
                                      (value !== 3 ||
                                        item?.exchange_status === 3)
                                  )?.map(([value, status]: any) => (
                                    <MenuItem
                                      key={value}
                                      value={String(value)}
                                      disabled={
                                        item?.exchange_status === 2
                                          ? value > item?.exchange_status + 2
                                          : item?.exchange_status === 3
                                            ? value > item?.exchange_status + 1
                                            : value >
                                                item?.exchange_status + 1 ||
                                              value < item?.exchange_status
                                      }
                                    >
                                      {EXCHANGE_STATUS_LABELS[value] || status}
                                    </MenuItem>
                                  ))}
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell>
                          <Box
                            sx={{
                              display: "flex",
                              gap: 1,
                              justifyContent: "center",
                            }}
                          >
                            {item?.Return_status === 4 ||
                            item?.exchange_status ===
                              3 ? null : item?.Return_status >= 3 ||
                              item?.exchange_status >= 2 ? (
                              <Box sx={{ cursor: "pointer" }}>
                                <Chip
                                  label={t.main.accepted}
                                  variant="outlined"
                                  sx={{ borderColor: "#2B604C" }}
                                />
                              </Box>
                            ) : (
                              <Chip
                                label={t.main.accept}
                                variant="outlined"
                                sx={{ borderColor: "#2B604C" }}
                                onClick={() => {
                                  if (value === 0) {
                                    handleAcceptRejectExchange(item?.id, 1);
                                  } else {
                                    handleAcceptRejectReturn(item?.id, 1);
                                  }
                                }}
                              />
                            )}

                            {item?.Return_status === 4 ||
                            item?.exchange_status === 3 ? (
                              <Box sx={{ cursor: "pointer" }}>
                                <Chip
                                  label={t.main.rejected}
                                  variant="outlined"
                                  sx={{ borderColor: "red" }}
                                />
                              </Box>
                            ) : item?.Return_status >= 3 ||
                              item?.exchange_status >= 2 ? null : (
                              <Chip
                                label={t.main.reject}
                                variant="outlined"
                                sx={{ borderColor: "red" }}
                                onClick={() => {
                                  if (value === 0) {
                                    handleAcceptRejectExchange(item?.id, 2);
                                  } else {
                                    handleAcceptRejectReturn(item?.id, 2);
                                  }
                                }}
                              />
                            )}
                          </Box>
                        </TableCell>
                        {/* <TableCell>
                          <Box className="table_actions">
                            <IconButton
                              onClick={() =>
                                navigate(
                                  `/manage-return-exchange/details/${item?.id}`,
                                  {
                                    state: value === 0 ? 2 : 1,
                                  }
                                )
                              }
                            >
                              <VisibilityIcon />
                            </IconButton>
                          </Box>
                        </TableCell> */}
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Card>

        {/* {productsData.length > 0 && (
          <Pagination
            setPage={setPage}
            module={productsData}
            page={page}
            onPageChange={setPage}
            totalPages={totalPages}
            limit={limit}
            setLimit={setLimit}
          />
        )} */}
      </div>
    </div>
  );
};

export default ManageReturnExchange;
